module.exports = __webpack_public_path__ + "img/sitemap.0b025120.png";